import React from 'react'
import { Modal, Button, Alert } from 'react-bootstrap'
import useGetUserPhoneNumbers from 'hooks/use-get-user-phone-numbers'
import useReactivatePhoneNumber from 'hooks/use-reactivate-phone-number'
import { PhoneNumber } from 'interfaces/phone-number'

interface ReactivatePhoneNumberModalProps {
  show: boolean
  onHide: () => void
  userId: string
  userName?: string
}

const ReactivatePhoneNumberModal: React.FC<ReactivatePhoneNumberModalProps> = ({
  show,
  onHide,
  userId,
  userName,
}) => {
  const { data: phoneNumbers, isLoading } = useGetUserPhoneNumbers(userId)
  const reactivatePhoneNumber = useReactivatePhoneNumber()

  const inactivePhoneNumbers = phoneNumbers?.filter(
    (phoneNumber: PhoneNumber) => !phoneNumber.active
  )

  const handleReactivate = (phoneNumber: PhoneNumber) => {
    if (
      window.confirm(
        `Are you sure you want to reactivate ${phoneNumber.number}?`
      )
    ) {
      reactivatePhoneNumber.mutate(phoneNumber.id.toString(), {
        onSuccess: () => {
          onHide()
        },
      })
    }
  }

  return (
    <Modal show={show} onHide={onHide} size="sm">
      <Modal.Header>
        <Modal.Title>
          Reactivate Twilio Number {userName && `for ${userName}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <p>Loading inactive Twilio numbers...</p>
        ) : !inactivePhoneNumbers || inactivePhoneNumbers.length === 0 ? (
          <Alert variant="info">
            No inactive Twilio numbers found for this user.
          </Alert>
        ) : (
          <>
            <p>Click on a Twilio number to reactivate it:</p>
            <div className="d-grid gap-2">
              {inactivePhoneNumbers.map((phoneNumber: PhoneNumber) => (
                <Button
                  key={phoneNumber.id}
                  variant="outline-success"
                  onClick={() => handleReactivate(phoneNumber)}
                  disabled={reactivatePhoneNumber.isLoading}
                >
                  {phoneNumber.number}
                </Button>
              ))}
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ReactivatePhoneNumberModal
